/* Velocity theme core — no dependencies, ~7KB minified.
   Everything is event-delegated so new sections added by the Theme Editor
   work without re-binding. */
(function () {
  'use strict';

  var root = document.documentElement;
  var cfg = window.themeConfig || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------------ utils */
  function debounce(fn, wait) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }
  function money(cents) {
    var f = cfg.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }
  function lockScroll(on) { document.body.classList.toggle('no-scroll', on); }

  /* ------------------------------------------------------------------ toast */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-open');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-open'); }, 2600);
  }
  window.themeToast = toast;

  /* ------------------------------------------------- overlay panels (drawers) */
  var scrim = $('[data-scrim]');
  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    if (scrim) scrim.classList.add('is-open');
    lockScroll(true);
    var f = el.querySelector('[autofocus], button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closePanels() {
    $$('.is-open[data-panel]').forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
    if (scrim) scrim.classList.remove('is-open');
    lockScroll(false);
  }
  window.themeOpenPanel = openPanel;
  window.themeClosePanels = closePanels;

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-panel-open]');
    if (open) { e.preventDefault(); openPanel($('#' + open.getAttribute('data-panel-open'))); return; }
    if (e.target.closest('[data-panel-close]') || e.target.hasAttribute('data-scrim')) { closePanels(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePanels(); } });

  /* ------------------------------------------------ mobile nav sub-menu toggle */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-subnav-toggle]');
    if (!t) return;
    e.preventDefault();
    var list = t.parentElement.querySelector('.mnav__sub');
    if (!list) return;
    var open = list.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ------------------------------------------------------------------- tabs */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[role="tab"]');
    if (!tab) return;
    var group = tab.closest('[role="tablist"]');
    if (!group) return;
    e.preventDefault();
    var scope = group.closest('[data-tab-scope]');
    if (!scope) return;
    $$('[role="tab"]', group).forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
    tab.setAttribute('aria-selected', 'true');
    var id = tab.getAttribute('aria-controls');
    $$('[role="tabpanel"]', scope).forEach(function (p) {
      if (p.closest('[data-tab-scope]') !== scope) return;
      p.hidden = p.id !== id;
    });
  });

  /* --------------------------------------------------------------- carousels */
  function syncCarousel(car) {
    var vp = $('[data-carousel-viewport]', car);
    if (!vp) return;
    var prev = $('[data-carousel-prev]', car), next = $('[data-carousel-next]', car);
    var max = vp.scrollWidth - vp.clientWidth - 2;
    if (prev) prev.disabled = vp.scrollLeft <= 2;
    if (next) next.disabled = vp.scrollLeft >= max;
    var dots = $$('[data-carousel-dot]', car);
    if (dots.length) {
      var per = Math.max(1, Math.round(vp.clientWidth / (vp.firstElementChild ? vp.firstElementChild.offsetWidth + 20 : 1)));
      var page = Math.round(vp.scrollLeft / (vp.clientWidth || 1));
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === page ? 'true' : 'false'); });
      void per;
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev],[data-carousel-next],[data-carousel-dot]');
    if (!btn) return;
    var car = btn.closest('[data-carousel]');
    var vp = $('[data-carousel-viewport]', car);
    if (!vp) return;
    if (btn.hasAttribute('data-carousel-dot')) {
      vp.scrollTo({ left: vp.clientWidth * parseInt(btn.getAttribute('data-carousel-dot'), 10), behavior: 'smooth' });
    } else {
      var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
      vp.scrollBy({ left: dir * vp.clientWidth * 0.9, behavior: 'smooth' });
    }
  });
  function initCarousels(scope) {
    $$('[data-carousel]', scope || document).forEach(function (car) {
      var vp = $('[data-carousel-viewport]', car);
      if (!vp || vp._bound) return;
      vp._bound = true;
      vp.addEventListener('scroll', debounce(function () { syncCarousel(car); }, 80), { passive: true });
      syncCarousel(car);
    });
  }

  /* ---------------------------------------------------------- scroll reveal */
  var io;
  function initReveal(scope) {
    if (!cfg.animate || !('IntersectionObserver' in window)) {
      $$('.reveal', scope || document).forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    $$('.reveal:not(.is-in)', scope || document).forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------- cart */
  var cartCountEls = function () { return $$('[data-cart-count]'); };

  function refreshCartUI(cart) {
    cartCountEls().forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  function renderDrawer() {
    var drawer = $('#cart-drawer');
    if (!drawer) return Promise.resolve();
    return fetch(cfg.routes.cart + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#cart-drawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
      });
  }

  function addToCart(payload, button) {
    if (button) { button.setAttribute('aria-busy', 'true'); }
    return fetch(cfg.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.data.description || res.data.message || cfg.strings.cartError); }
        return fetch(cfg.routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartUI(cart);
        if (cfg.cartType === 'drawer') {
          return renderDrawer().then(function () { openPanel($('#cart-drawer')); });
        }
        toast(cfg.strings.addedToCart);
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () { if (button) button.removeAttribute('aria-busy'); });
  }
  window.themeAddToCart = addToCart;

  function changeLine(key, qty, el) {
    var row = el && el.closest('.citem, tr');
    if (row) row.classList.add('loading');
    return fetch(cfg.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshCartUI(cart);
        if ($('#cart-drawer')) renderDrawer();
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  /* quick add from product cards */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-quick-add]');
    if (!add) return;
    e.preventDefault();
    var id = add.getAttribute('data-variant-id');
    if (!id) { window.location.href = add.getAttribute('data-url'); return; }
    addToCart({ items: [{ id: Number(id), quantity: 1 }] }, add);
  });

  /* cart line controls */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-key'), 0, rm); return; }
    var step = e.target.closest('[data-line-step]');
    if (step) {
      e.preventDefault();
      var input = step.parentElement.querySelector('input');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.getAttribute('data-line-step'), 10));
      input.value = next;
      changeLine(step.getAttribute('data-key'), next, step);
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0), input);
  });

  /* generic quantity steppers (product form) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = Math.max(parseInt(input.min || 1, 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* product form submit -> ajax */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || cfg.cartType !== 'drawer') return;
    e.preventDefault();
    var fd = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    var payload = { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] };
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    if (Object.keys(props).length) payload.items[0].properties = props;
    addToCart(payload, btn);
  });

  /* --------------------------------------------------------- predictive search */
  function initSearch() {
    if (!cfg.predictiveSearch) return;
    $$('[data-search-form]').forEach(function (form) {
      if (form._bound) return;
      form._bound = true;
      var input = $('input[type="search"], input[name="q"]', form);
      var out = $('[data-search-results]', form);
      if (!input || !out) return;
      var run = debounce(function () {
        var q = input.value.trim();
        if (q.length < 2) { out.hidden = true; out.innerHTML = ''; return; }
        var url = cfg.routes.predictive + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('[data-predictive-inner]');
          out.innerHTML = res ? res.innerHTML : '<p class="psearch__empty">' + cfg.strings.noResults + '</p>';
          out.hidden = false;
        }).catch(function () { out.hidden = true; });
      }, 220);
      input.addEventListener('input', run);
      input.addEventListener('focus', run);
      document.addEventListener('click', function (ev) {
        if (!form.contains(ev.target)) out.hidden = true;
      });
    });
  }

  /* ------------------------------------------------------- prefetch on hover */
  function initPrefetch() {
    if (!cfg.prefetch) return;
    var seen = {};
    document.addEventListener('mouseover', function (e) {
      var a = e.target.closest('a[href^="/"]');
      if (!a || seen[a.href] || a.hasAttribute('data-no-prefetch')) return;
      seen[a.href] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch'; l.href = a.href; l.as = 'document';
      document.head.appendChild(l);
    }, { passive: true });
  }

  /* --------------------------------------------------- category circle focus */
  function initCats(scope) {
    $$('[data-cats]', scope || document).forEach(function (list) {
      if (list._bound) return;
      list._bound = true;
      var mark = function () {
        var mid = list.scrollLeft + list.clientWidth / 2;
        var best = null, bd = Infinity;
        $$('.cat', list).forEach(function (c) {
          var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
          if (d < bd) { bd = d; best = c; }
        });
        $$('.cat', list).forEach(function (c) { c.classList.toggle('is-active', c === best); });
      };
      list.addEventListener('scroll', debounce(mark, 60), { passive: true });
      mark();
    });
  }

  /* --------------------------------------------------- collection view toggle */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.viewtoggle button');
    if (!btn) return;
    var group = btn.closest('.viewtoggle');
    var grid = document.querySelector('.pgrid');
    if (!grid) return;
    $$('button', group).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    var wide = Array.prototype.indexOf.call(group.children, btn) === 1;
    grid.classList.toggle('pgrid--4', !wide);
    grid.classList.toggle('pgrid--3', wide);
  });

  /* ------------------------------------------------------------------- boot */
  function boot(scope) {
    initCarousels(scope);
    initReveal(scope);
    initCats(scope);
    initSearch();
  }

  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  window.addEventListener('load', initPrefetch);

  /* Theme editor hooks */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });

  void root;
})();
